import { Fragment } from 'react';
import { Transition } from '@headlessui/react';

export default function Toast({ 
  show = false, 
  message, 
  type = 'success', 
  onClose,
  showCloseButton = true
}) {
  return (
    <Transition
      show={show}
      as={Fragment}
      enter="transform ease-out duration-300 transition"
      enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
      enterTo="translate-y-0 opacity-100 sm:translate-x-0"
      leave="transition ease-in duration-100"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className="fixed inset-x-0 bottom-8 flex justify-center items-center px-4 z-50">
        <div className="max-w-2xl w-full bg-white shadow-xl rounded-xl pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden transform transition-all hover:scale-105">
          {/* Background floating hearts */}
          <div className="absolute inset-0 overflow-hidden">
            {[...Array(4)].map((_, i) => (
              <div
                key={i}
                className="floating-heart absolute text-red-500/15"
                style={{
                  left: `${20 + (i * 20)}%`,
                  animationDelay: `${i * 0.5}s`,
                  fontSize: `${16 + (i * 2)}px`
                }}
              >
                ❤️
              </div>
            ))}
          </div>

          <div className="p-6 relative">
            <div className="flex items-center justify-center">
              <div className="flex-shrink-0 transform scale-125 -translate-y-1">
                {type === 'success' && (
                  <span className="text-5xl animate-bounce">🎉</span>
                )}
                {type === 'hug' && (
                  <span className="text-5xl animate-bounce">🤗</span>
                )}
              </div>
              <div className="ml-6 flex-1 text-center">
                <p className="text-lg font-medium text-gray-900">
                  {message}
                </p>
              </div>
              {showCloseButton && (
                <div className="ml-6 flex-shrink-0">
                  <button
                    className="rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none p-2 hover:bg-gray-100 transition-colors"
                    onClick={onClose}
                  >
                    <span className="sr-only">Close</span>
                    <svg className="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Transition>
  );
} 